// bao migrate skip
// bao migrate - module not found: import BaoSearchDialogConfig from "models/bao-search-dialog-config";
import GenericListTab from "./generic-list-tab";
import baoSearchDialog from "./bao-search-dialog";
import Bao from "./../services/bao-service";
import * as ko from "knockout";
import BaoDialog from "./bao-dialog";
abstract class GenericListSearchTab extends GenericListTab implements Factories.GenericListSearchTab {
    abstract SearchType(): string;

    /**
     * This method is used to save selected item from search dialog and refresh the list
     * @param searchItem Selected item from search dialog
     * @returns jQueryPromise<any>
     */
    SaveSearchItem(searchItem: any): JQueryPromise<any> {
        this.TabPage.IsLoading(true);
        return this.SaveSelectedItem(searchItem).then(() => {
            if(searchItem) {
                return this.Get().then(() => {
                    this.TabPage.DirtyFlag(true);
                });
            }
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    /**
     * This method is used to save selected item from search dialog
     * @param item Selected item from search dialog
     * @returns JQueryPromise<boolean>
     */
    protected SaveSelectedItem(item: any): JQueryPromise<boolean> {
        return Bao.post(this.UrlSaveSearchItem(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: ko.unwrap(item.PrimaryKeyValue)
        }), (serverResult: {
            Message: string;
            Result: boolean;
        }) => {
            if (serverResult.Result) {
                return true;
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, serverResult.Message, "info");
                return false;
            }
        });
    }

    /**
     * This method is used to save multiple selected items from search dialog
     * @param searchVM Data(object) of selected items from search dialog
     */
    SaveSearchItems(searchVM: any) {
        this.TabPage.IsLoading(true);
        searchVM.Selection().reduce((prevPromise: Promise<any>, item: any) => {
            return prevPromise.then(() => {
                return this.SaveSelectedItem(item)
                    .then((serverResult: boolean) => {
                        if (!serverResult) {
                            Promise.reject();
                        }
                    });
            });
        },
            Promise.resolve()
        )
        .then(() => {
            return this.Get().then(() => {
                this.TabPage.DirtyFlag(true);
            });
        })
        .catch(() => {
            this.TabPage.IsLoading(false);
        })
    }

    /**
     * This method is used to set MultiSelect option's value in Search dialog, the defualt value is true.
     * @returns true or false
     */
    MultiSelect(): boolean {
        return true;
    }

    SearchConfig: Models.BaoSearchDialogConfig = {
        SearchType: this.SearchType(),
        AutoSearch: true,
        MultiSelect: this.MultiSelect(),
        ObjectId: ko.observable<string>(),
        ObjectValue: "ModelTitle",
        CustomFilter: { SessionTabId: this.SessionTabId },
        ApplyItemCallback: (searchVM) => {
            this.SaveSearchItems(searchVM);
        }
    };
    Dialog(id: string): JQueryPromise<void> {
        var def = $.Deferred<void>();
        def.resolve();
        var searchDialog = new baoSearchDialog();
        searchDialog.InitSearcher(this.SearchConfig);
        return def.promise();
    }
    UrlSaveSearchItem() {
        return this.ControllerUrl + "/SaveSearchItem";
    }
}
export default GenericListSearchTab;